import { computed } from "@vue/composition-api";
import { BusinessLoginState, BusinessLoginGetters } from "./types";

export default function gettersFactory(state: BusinessLoginState): BusinessLoginGetters {    
    return {    
        hasBusinessLogin: computed(() => { 
            return null != state.businessId 
        }),
        isProcessing: computed(() => { 
            return state.isLoading 
        })
    }
}
